import axiosInstance from './axios';
import { ACCOUNT_DELETION_API_ENDPOINTS } from 'Pages/Auth/AccountDeletion/constants';

/**
 * Submits a public account deletion request for the given email.
 *
 * @param {{ email: string }} data - Payload containing the account email.
 * @returns {Promise<import('axios').AxiosResponse>} API response with confirmation message.
 */
export const requestAccountDeletion = async (data) =>
  axiosInstance.post(ACCOUNT_DELETION_API_ENDPOINTS.REQUEST, data);

/**
 * Verifies an account deletion request using the token from the email link.
 *
 * @param {{ token: string }} data - Payload containing the signed verification token.
 * @returns {Promise<import('axios').AxiosResponse>} API response with verification status.
 */
export const verifyAccountDeletion = async (data) =>
  axiosInstance.post(ACCOUNT_DELETION_API_ENDPOINTS.VERIFICATION, data);
